import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Divider, Grid } from "@material-ui/core";
import CardTurno from "../../componentes/CardTurno";
import ProximoTurno from "../../componentes/ProximoTurno";
import TurnoActual from "../../componentes/TurnoActual";
import Permission from "../../helpers/Permission";
import { getPermisoDefinicion } from "helpers/helpers";
import { PERMISOS } from "helpers/PermisosConfig";
import { Link, useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TurnosForm from "admin/turnos/TurnosForm";
import axios from "../../helpers/API";
import { errorBackendMsg } from "helpers/helpers";
import format from "date-fns/format";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ padding: "20px", width: "85%", overflowY: "scroll" }}
    >
      <Grid container spacing={2}>
        {children}
      </Grid>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: 224,
    boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.25)",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  cardCrear: {
    height: 120,
    width: "100%",
    color: "white",
    fontSize: "1.3rem",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  link: {
    color: "white",

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
      color: "white",
    },
  },
}));

function Dashboard({ navigation }) {
  const classes = useStyles();
  const history = useHistory();

  const [value, setValue] = React.useState(0);
  const [loadingPermisos, setLoadingPermisos] = useState(true);
  const [permisos, setPermisos] = useState([]);
  const [stepper, setStepper] = React.useState(false);
  const [keyLista, setKeyLista] = React.useState(0);

  const [proximosTurnos, setProximosTurnos] = React.useState([]);
  const [fechasPreview, setFechasPreview] = React.useState([]);

  const [turnosLista, setTurnosLista] = React.useState([]);
  const [cantTurnosDia, setCantidadTurnosDia] = React.useState(null);

  //MODALS
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);
  const [mensajeInfo, setMensajeInfo] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    crearFechasLista();
    consultarCantTurnosDia();
    consultarPermisos();
    consultarTurnosFuturo();
    consultarTurnoTabs(format(new Date(), "dd/MM/yyyy"));
  }, []);

  useEffect(() => {
    consultarTurnoTabs(format(new Date(), "dd/MM/yyyy"));
  }, [refresh]);

  const crearFechasLista = () => {
    let initialTime = new Date(),
      endTime = new Date(new Date().setDate(new Date().getDate() + 10));
    const arrTime = [];
    for (let q = initialTime; q <= endTime; q.setDate(q.getDate() + 1)) {
      arrTime.push(format(q, "dd/MM/yyyy"));
    }
    setFechasPreview(arrTime);
  };

  const consultarPermisos = () => {
    const permissionConfig = {
      modulo: getPermisoDefinicion(PERMISOS.P_DASHBOARD)["modulo"],
      pantalla: getPermisoDefinicion(PERMISOS.P_DASHBOARD)["pantalla"],
      history: history,
      setLoadingPermisos: setLoadingPermisos,
      setAllowedAction: setPermisos,
    };

    new Permission(permissionConfig).applyPermission();
  };

  const consultarTurnosFuturo = () => {
    axios
      .post("/turnos/listar", {
        nroTurno: "",
        lugarId: "",
        servicioId: "",
        servidorId: "",
        fechaDesde: format(new Date(), "dd/MM/yyyy"),
        fechaHasta: format(new Date(), "dd/MM/yyyy"),
        horaDesde: format(new Date(), "HH:mm"),
        nroDoc: "",
        limite: 3,
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setProximosTurnos(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const consultarCantTurnosDia = () => {
    axios
      .post("/turnos/cantTurnos", {
        fechaDesde: format(new Date(), "dd/MM/yyyy"),
        fechaHasta: format(new Date(), "dd/MM/yyyy"),
        horaDesde: format(new Date(), "HH:mm"),
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setCantidadTurnosDia(response.data.cantTurnos);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const consultarTurnoTabs = (fecha) => {
    axios
      .post("/turnos/listar", {
        nroTurno: "",
        lugarId: "",
        servicioId: "",
        servidorId: "",
        fechaDesde: fecha,
        fechaHasta: fecha,
        nroDoc: "",
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setTurnosLista(response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  return (
    <>
      {loadingPermisos ? (
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Grid container spacing={2}>
          <Grid item md={9}>
            <Card style={{ height: 120, width: "100%" }}>
              <CardContent>
                <Typography variant="h5">Dashboard</Typography>
                {/* <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse bibendum orci sed elit congue ultrices.
            </Typography> */}
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={3}>
            <Button
              className={classes.cardCrear}
              disabled={!permisos.includes("reservar")}
              variant="contained"
              color="secondary"
              onClick={() => history.push("/reservaTurnoInterno") }
            >
                Reservar
            </Button>
          </Grid>
          <Grid item md={12}>
            <Card elevation={2}>
              <CardContent>
                <Typography variant="h5">Próximos Turnos del día</Typography>
                {proximosTurnos.length == 0 ? (
                  <Grid item md={12 / proximosTurnos.length}>
                    <Typography>No hay más turnos el dia de hoy</Typography>
                  </Grid>
                ) : (
                  <Typography>
                    Mostrando {proximosTurnos.length} de {cantTurnosDia} turnos
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
          {proximosTurnos.length > 0 &&
            proximosTurnos.map((turno) => {
              return (
                <Grid item md={12 / proximosTurnos.length}>
                  <ProximoTurno turno={turno} />
                </Grid>
              );
            })}
          <Grid item md={12}>
            <div
              className={classes.root}
              style={{ height: 400, width: "100%" }}
            >
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
              >
                {fechasPreview.map((fecha) => {
                  return (
                    <Tab
                      label={fecha}
                      key={fecha}
                      onClick={() => consultarTurnoTabs(fecha)}
                    />
                  );
                })}
              </Tabs>

              {fechasPreview.map((fecha, i) => {
                return (
                  <TabPanel
                    value={value}
                    index={i}
                    style={{ overflowY: "scroll" }}
                  >
                    {turnosLista.length == 0 ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography>
                          No Hay Turnos para la fecha seleccionada
                        </Typography>
                      </div>
                    ) : (
                      turnosLista.map((turno) => {
                        return (
                          <CardTurno
                            key={turno.id}
                            turno={turno}
                            puedeCancelar={permisos.includes("cancelarTurno")}
                            puedePonerAsistir={permisos.includes("marcarAsistencia")}
                            puedePonerPendiente={permisos.includes("desmarcarAsistencia")}
                            puedeDescargarComprobante={permisos.includes("descargarComprobante")}
                            setRefresh={setRefresh}
                            refresh={refresh}
                          />
                        );
                      })
                    )}
                  </TabPanel>
                );
              })}
            </div>
          </Grid>
          )
        </Grid>
      )}
    </>
  );
}

export default Dashboard;
